/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsCustomIdleResource extends models.RecommendationBaseForFinopsCustomResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsCustomIdleResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsCustomIdleResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsCustomIdleResource>): RecommendationForFinopsCustomIdleResource {
        let obj = Object.assign(new RecommendationForFinopsCustomIdleResource(), model);
        RecommendationForFinopsCustomIdleResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsCustomIdleResource>): RecommendationForFinopsCustomIdleResource {
        if (!model) return null;
        return RecommendationForFinopsCustomIdleResource.newInstance(<RecommendationForFinopsCustomIdleResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsCustomIdleResource) {
        if (!obj) return;

        models.RecommendationForFinopsCustomIdleResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsCustomIdleResource): boolean {
        if (models.RecommendationBaseForFinopsCustomResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsCustomIdleResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
